import baseService from "../services/BaseService";

export const userAddressUpdate = async (orderId, values) =>
  baseService.post(`order/updateAddress/${orderId}`, values);
export const userDateUpdate = async (orderId, values) =>
  baseService.post(`order/updateDate/${orderId}`, values);
